import Box from "@mui/joy/Box";
import Stack from "@mui/joy/Stack";
import Tabs from "@mui/joy/Tabs";
import TabList from "@mui/joy/TabList";
import Tab from "@mui/joy/Tab";
import TabPanel from "@mui/joy/TabPanel";
import Typography from "@mui/joy/Typography";
import BottomSheet from "./BottomSheet";
import { BASE_LAYOUTS, framedLayoutsForSize } from "../../layouts.config";


function LayoutThumb({ layout, active, onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        p: "10px 8px 8px",
        borderRadius: "12px",
        border: active
          ? "2px solid color-mix(in srgb, var(--joy-palette-primary-400) 70%, transparent)"
          : "2px solid var(--joy-palette-divider)",
        bgcolor: active
          ? "color-mix(in srgb, var(--joy-palette-primary-500) 10%, transparent)"
          : "background.level1",
        cursor: "pointer",
        display: "flex", flexDirection: "column", alignItems: "center", gap: 1,
        transition: "all 0.15s",
        WebkitTapHighlightColor: "transparent",
        "&:active": { transform: "scale(0.95)" },
      }}
    >
      <Box sx={{ color: "primary.600", opacity: active ? 1 : 0.5 }}>{layout.icon}</Box>
      <Typography
        level="body-xs"
        sx={{
          fontSize: "11px", textAlign: "center", lineHeight: 1.2,
          color: active ? "primary.700" : "text.secondary",
          fontWeight: active ? 700 : 400,
        }}
      >
        {layout.label}
      </Typography>
    </Box>
  );
}


export default function BottomSheetTemplates({ open, onClose, page, setPageLayout, activePage, activeSide, bookSize }) {
  const availableFramed = framedLayoutsForSize(bookSize);
  const isCover    = activePage === 0;
  const isEndpaper = activePage === 1;

  return (
    <BottomSheet open={open} onClose={onClose} title="Шаблоны страниц">
      <Box sx={{ p: 2.5 }}>
        {isCover && (
          <Box sx={{ py: 6, textAlign: "center" }}>
            <Typography level="body-sm" sx={{ color: "text.tertiary" }}>
              Обложка — фиксированный шаблон, изменить нельзя.
            </Typography>
          </Box>
        )}

        {isEndpaper && !isCover && (
          <Box>
            <Typography level="body-xs" sx={{ color: "text.tertiary", mb: 2, textAlign: "center" }}>
              Для форзаца доступна только правая страница
            </Typography>
            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1.5 }}>
              {BASE_LAYOUTS.map(layout => (
                <LayoutThumb
                  key={layout.id}
                  layout={layout}
                  active={page?.rightLayoutId === layout.id}
                  onClick={() => {
                    setPageLayout("right", layout.id);
                    onClose();
                  }}
                />
              ))}
            </Box>

            <Typography level="body-xs" sx={{ color: "text.tertiary", mt: 2.5, mb: 1.5, textAlign: "center", fontWeight: 700 }}>
              Шаблоны листов с белыми краями
            </Typography>
            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1.5 }}>
              {availableFramed.map(layout => (
                <LayoutThumb
                  key={layout.id}
                  layout={layout}
                  active={page?.rightLayoutId === layout.id}
                  onClick={() => {
                    setPageLayout("right", layout.id);
                    onClose();
                  }}
                />
              ))}
            </Box>
          </Box>
        )}

        {!isCover && !isEndpaper && (
          <Box>
            <Typography level="body-xs" sx={{ color: "text.tertiary", mb: 2, textAlign: "center" }}>
              {activeSide === "left" ? "Шаблон левой страницы" : "Шаблон правой страницы"}
            </Typography>
            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1.5 }}>
              {BASE_LAYOUTS.map(layout => (
                <LayoutThumb
                  key={layout.id}
                  layout={layout}
                  active={activeSide === "left"
                    ? page?.leftLayoutId === layout.id
                    : page?.rightLayoutId === layout.id}
                  onClick={() => {
                    setPageLayout(activeSide || "left", layout.id);
                    onClose();
                  }}
                />
              ))}
            </Box>

            <Typography level="body-xs" sx={{ color: "text.tertiary", mt: 2.5, mb: 1.5, textAlign: "center", fontWeight: 700 }}>
              Шаблоны листов с белыми краями
            </Typography>
            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1.5 }}>
              {availableFramed.map(layout => (
                <LayoutThumb
                  key={layout.id}
                  layout={layout}
                  active={activeSide === "left"
                    ? page?.leftLayoutId === layout.id
                    : page?.rightLayoutId === layout.id}
                  onClick={() => {
                    setPageLayout(activeSide || "left", layout.id);
                    onClose();
                  }}
                />
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </BottomSheet>
  );
}